import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PageStyles.css";

const ApplyForm = () => {
  const navigate = useNavigate();
  const [formType, setFormType] = useState("delegate");

  const formEndpoints = {
    delegate: "https://formspree.io/f/mldrvkqa",
    delegation: "https://formspree.io/f/xayvzzgr",
    chair: "https://formspree.io/f/mwkjyebd",
    admin: "https://formspree.io/f/xqazrdyb",
  };

  return (
    <section className="apply-form-page">
      {/* 🔹 Top Selector */}
      <div className="form-type-selector">
        <label>Application Type: </label>
        <select
          value={formType}
          onChange={(e) => setFormType(e.target.value)}
          className="form-type-dropdown"
        >
          <option value="delegate">🎓 Delegate Application</option>
          <option value="delegation">🏫 Delegation Application</option>
          <option value="chair">🪶 Chair Application</option>
          <option value="admin">🛠️ Administrative Staff Application</option>
        </select>
      </div>

      <div className="apply-form-container">

        {/* 🔹 Delegate Form */}
        {formType === "delegate" && (
          <form
            action={formEndpoints.delegate}
            method="POST"
            className="apply-form-box"
          >
            <h2>Delegate Application Form</h2>

            <label>Full Name</label>
            <input type="text" name="name" required />

            <label>National ID Number</label>
            <input type="text" name="national_id" maxLength="11" required />

            <label>Email</label>
            <input type="email" name="email" required />

            <label>Phone Number</label>
            <input type="text" name="phone" required />

            <label>Institution / School</label>
            <input type="text" name="school" required />

            <label>Grade</label>
            <input
              type="text"
              name="grade"
              placeholder="Example: 11th Grade"
              required
            />

            <label>English Proficiency</label>
            <select name="english_level" required>
              <option value="">Select</option>
              <option>A1</option>
              <option>A2</option>
              <option>B1</option>
              <option>B2</option>
              <option>C1</option>
              <option>C2</option>
            </select>

            <label>Preferred Committee</label>
            <input
              type="text"
              name="committee"
              placeholder="e.g. WHO, UNHRC..."
              required
            />

            <label>Country Preferences</label>
            <input
              type="text"
              name="countries"
              placeholder="List 3 countries (in order)"
            />

            <label>Previous MUN Experience</label>
            <textarea name="experience" rows="3" placeholder="If any..."></textarea>

            <label>Motivation Letter</label>
            <textarea
              name="motivation"
              rows="4"
              placeholder="Why do you want to join?"
              required
            ></textarea>

            <button type="submit" className="apply-submit-btn">
              Submit Application
            </button>
            <p className="apply-info-text">
              Your application will be reviewed by the Secretariat.
            </p>
          </form>
        )}

        {/* 🔹 Delegation Form */}
        {formType === "delegation" && (
          <form
            action={formEndpoints.delegation}
            method="POST"
            className="apply-form-box"
          >
            <h2>Delegation Application Form</h2>
            <p className="apply-info-text">
              For advisors applying on behalf of their school.
            </p>

            <label>Advisor First Name</label>
            <input type="text" name="advisor_name" required />

            <label>Advisor Last Name</label>
            <input type="text" name="advisor_surname" required />

            <label>National ID Number</label>
            <input type="text" name="national_id" maxLength="11" required />

            <label>Gender</label>
            <select name="gender" required>
              <option value="">Select</option>
              <option>Female</option>
              <option>Male</option>
            </select>

            <label>School / Campus</label>
            <input type="text" name="school" required />

            <label>Title</label>
            <input
              type="text"
              name="title"
              placeholder="e.g. MUN Advisor"
              required
            />

            <label>Phone Number</label>
            <input type="text" name="phone" required />

            <label>Number of Delegates</label>
            <input type="number" name="delegate_count" required />

            <label>Students’ Ages</label>
            <input type="text" name="student_ages" required />

            <label>Grades</label>
            <input type="text" name="student_grades" required />

            <label>English Levels</label>
            <input
              type="text"
              name="english_levels"
              placeholder="e.g. B1, B2, C1..."
              required
            />

            <label>Emergency Contact Information</label>
            <textarea name="emergency_contact" rows="3" required></textarea>

            <label>Special Conditions (if any)</label>
            <textarea name="special_conditions" rows="3"></textarea>

            <label>Additional Notes</label>
            <textarea name="notes" rows="3"></textarea>

            <button type="submit" className="apply-submit-btn">
              Submit Delegation
            </button>
          </form>
        )}

        {/* 🔹 Chair Form */}
        {formType === "chair" && (
          <form
            action={formEndpoints.chair}
            method="POST"
            className="apply-form-box"
          >
            <h2>Chair Application Form</h2>

            <label>Full Name</label>
            <input type="text" name="name" required />

            <label>National ID Number</label>
            <input type="text" name="national_id" maxLength="11" required />

            <label>Email</label>
            <input type="email" name="email" required />

            <label>Phone Number</label>
            <input type="text" name="phone" required />

            <label>Institution / University</label>
            <input type="text" name="institution" required />

            <label>Previous Chairing Experience</label>
            <textarea name="chair_experience" rows="3"></textarea>

            <label>Committee Preference</label>
            <input type="text" name="committee_preference" required />

            <label>Motivation</label>
            <textarea
              name="motivation"
              rows="4"
              placeholder="Why would you like to serve as a chair?"
              required
            ></textarea>

            <button type="submit" className="apply-submit-btn">
              Submit Chair Application
            </button>
            <p className="apply-info-text">
              Applications will be reviewed by the Secretariat.
            </p>
          </form>
        )}

        {/* 🔹 Admin Form */}
        {formType === "admin" && (
          <form
            action={formEndpoints.admin}
            method="POST"
            className="apply-form-box"
          >
            <h2>Administrative Staff Application Form</h2>

            <label>Full Name</label>
            <input type="text" name="name" required />

            <label>National ID Number</label>
            <input type="text" name="national_id" maxLength="11" required />

            <label>Email</label>
            <input type="email" name="email" required />

            <label>Phone Number</label>
            <input type="text" name="phone" required />

            <label>Institution / School</label>
            <input type="text" name="school" required />

            <label>Grade</label>
            <input type="text" name="grade" required />

            <label>English Proficiency</label>
            <select name="english_level" required>
              <option value="">Select</option>
              <option>A1</option>
              <option>A2</option>
              <option>B1</option>
              <option>B2</option>
              <option>C1</option>
              <option>C2</option>
            </select>

            <label>Motivation Letter</label>
            <textarea
              name="motivation"
              rows="4"
              placeholder="Why would you like to join the Administrative Staff?"
              required
            ></textarea>

            <button type="submit" className="apply-submit-btn">
              Submit Application
            </button>

            <p className="apply-info-text">
              Applications will be reviewed by the Secretariat.
            </p>
          </form>
        )}
      </div>

      {/* 🔙 Back Button */}
      <button className="back-btn" onClick={() => navigate(-1)}>
        ⬅ Back
      </button>
    </section>
  );
};

export default ApplyForm;
